<template>
  <div class="tuijian">
    <div class="home-three-title">
      <div class="text fourth-text">
        <img class="fourth-img" src="https://staticfile.xlcwx.com/m-images/yth/lzjxy/img/homeFourth/class.png" />
        <div class="text-slot">
          <slot>热门知识套餐</slot>
        </div>
      </div>
    </div>
    <div v-loading="nav.loading" :element-loading-text="'加载中'" ref="recommendBox" class="recommend"
      v-for="(nav, index) in collegeList" :key="index">
      <div class="title" :class="index == 0 ? 'm-t-0' : ''">
        <p class="schoole">{{ nav.pName }}</p>
        <div class="kind-list">
          <div class="kind-item" v-for="(nav2, index2) in nav.kindList" :key="index2"
            @click="handleNav(nav, nav2, index)" :class="nav.kind == nav2.pKind ? 'kind-on' : ''" v-if="index2 < 5">
            {{ nav2.pName }}
          </div>
        </div>
        <span class="more" @click="banxingkes(nav.pKind, nav.kind)">查看更多&nbsp;></span>
      </div>
      <div class="class-list">
        <div class="item" v-for="(item, index) in nav.projectList" :key="index" @click="banxingke(item)">
          <img class="item-img" :src="item.coachClassTypeImage" alt="" />
          <div class="content">
            <div class="item-title twoEllipsis">{{ item.coachClassTypeName }}</div>
            <div class="item-tips">
              <div class="contetn" v-for="(curForms, curindex) in item.curForms" :key="curindex">
                <span class="data-icon" v-if="curindex != 0"> / </span>
                {{ curForms }}
              </div>
            </div>
            <div class="item-price">
              <div class="price"><span class="price-icon">￥</span>{{ item.coachClassTypePrice }}</div>
              <div class="price-tips">人气值{{ item.commodityIdCount ? item.commodityIdCount : 0 }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/common.css'
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();
export default {
  components: {},
  data() {
    return {
      collegeList: [],
    }
  },
  created() {
    this.getSchool()
  },
  methods: {
    async getSchool() {
      await homeClient.getTenantKindZyList().then((res) => {
        this.collegeList = res.data
        this.collegeList.forEach((item) => {
          this.$set(item, 'loading', false)
          item.kind = item.kindList[0].pKind
          this.handleNav(item, item.kindList[0], this.collegeList.indexOf(item))
        })
      })
      this.$forceUpdate()
    },
    async handleNav(item, nav2, index) {
      this.collegeList[index].loading = true
      item.kind = nav2.pKind
      await homeClient.qbsJxyTutorial({
        pageSize: 8,
        pageNum: 1,
        projectId: nav2.pKind,
        lineType: 4,
      }).then((res) => {
        item.projectList = res.rows
        for (let cur of item.projectList) {
          if (cur.curForms) {
            cur.curForms = cur.curForms.split(',')
          } else {
            cur.curForms = []
          }
        }
      })
      this.collegeList[index].loading = false
      this.$forceUpdate()
    },
    banxingkes(schoole, kind) {
      let routeUrl = this.$router.resolve({
        path: `/allcurriculum/typeclass?schoole=${schoole}&kind=${kind}`,
      })
      window.open(routeUrl.href, '_blank')
    },
    toInformationDetails(item) {
      let routeUrl = this.$router.resolve({
        name: '新闻资讯详情',
        params: { id: item.id },
      })
      window.open(routeUrl.href, '_blank')
    },
    banxingke(item) {
      let routeUrl = this.$router.resolve({
        path: '/typeclassxq',
        query: {
          id: item.coachClassTypeId,
        },
      })
      window.open(routeUrl.href, '_blank')
    },
  },
}
</script>
<style lang="less" scoped>
.home-three-title {
  width: 1220px;
  padding-bottom: 30px;
  margin: auto !important;
}

.title {
  width: 1220px;
  margin: 20px auto 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .schoole {
    font-size: 20px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    flex-shrink: 0;
    margin-right: 40px;
  }

  .more {
    height: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei-Regular, Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    flex-shrink: 0;
    cursor: pointer;
  }

  .kind-list {
    width: 100%;
    height: auto;
    display: flex;
    height: 100%;
    align-items: center;

    .kind-item {
      height: 34px;
      line-height: 34px;
      padding: 0px 16px;
      background: #f1f1f1;
      border-radius: 17px 17px 17px 17px;
      margin-right: 24px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
    }

    .kind-on {
      color: #ffffff;
      background: linear-gradient(134deg, #ff9a51 0%, #ff5e51 100%);
    }
  }
}

.tuijian {
  width: 1220px;
  margin: 0px 0px 15px calc(50% - 610px);
}

.recommend {
  width: calc(1220px + 24px);
  height: auto;
  overflow: hidden;
  margin-bottom: 20px;

  .m-t-0 {
    margin-top: 0px !important;
  }

  .class-list {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;

    .item {
      width: 287px;
      padding-bottom: 10px;
      border-radius: 8px 8px 8px 8px;
      position: relative;
      opacity: 1;
      margin-right: 24px;
      margin-bottom: 24px;
      cursor: pointer;

      .item-img {
        position: absolute;
        width: 252px;
        height: 141px;
        border-radius: 8px 8px 8px 8px;
        opacity: 1;
        left: 18px;
        right: 18px;
        top: 0px;
      }

      .content {
        margin-top: 40px;
        width: 287px;
        height: 231px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        opacity: 1;
        padding: 112px 20px 0px;

        .item-title {
          height: 48px;
          font-size: 16px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #333333;
          line-height: 24px;
        }

        .item-tips {
          margin-top: 8px;
          font-size: 12px;
          font-family: Microsoft YaHei-Regular, Microsoft YaHei;
          font-weight: 400;
          color: #9098ab;
          height: 12px;
          line-height: 12px;
          display: flex;
        }

        .item-price {
          margin-top: 16px;
          display: flex;
          height: 18px;
          justify-content: space-between;

          .price {
            font-family: Microsoft YaHei-Regular;
            color: #ff5d51;
            font-size: 18px;
            line-height: 18px;
            font-weight: Bold;

            .price-icon {
              font-size: 14px;
              line-height: 14px;
              font-weight: 400;
            }
          }

          .price-tips {
            font-size: 14px;
            font-family: Microsoft YaHei-Regular, Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 14px;
          }
        }
      }
    }
  }
}

.cacelPrice {
  font-size: 16px !important;
  text-decoration: line-through;
}

::-webkit-scrollbar {
  display: none !important;
  scrollbar-width: none !important;
  -ms-overflow-style: none;
}
</style>
